import React, { useEffect, type ReactElement, useState } from 'react'
import { DatePicker, type DatePickerProps, Form, Input, Space } from 'antd'
import { connect } from 'react-redux'
import {
    type RegisterInterface,
    type PersonalDetails,
} from '../../../../../../Types/Client/RegisteredClients/Individual'
import dayjs from 'dayjs'
import moment from 'moment'
import commonStyles from '../../../../../../Utils/Common.less'
import { validateDate } from '../../../../../../Utils/ValidateDate'
import InputFieldNINumber from '../../../../../../Components/InputNINO'

const PersonalDetailsForm = (props: PersonalDetails): ReactElement => {
    const {
        individualTaps,
        setSelectedDateOfBirthFromChild,
        setSelectedDueDateFromChild,
    } = props
    const [form] = Form.useForm()
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [selectDusDate, setSelecteddueDate] = useState<string>('')

    useEffect(() => {
        const initialDate = moment(
            individualTaps?.individualPersonalDetails?.dateOfBirth,
            'M/D/YYYY HH:mm:ss A'
        )
        const formattedDate = initialDate.format('M/D/YYYY h:mm:ss A')
        setSelectedDate(formattedDate)
        setSelectedDateOfBirthFromChild(
            dayjs(formattedDate).format('DD/MM/YYYY')
        )
    }, [individualTaps?.individualPersonalDetails?.dateOfBirth])

    useEffect(() => {
        const initialDate = moment(
            individualTaps?.individualPersonalDetails?.dueDate,
            'M/D/YYYY HH:mm:ss A'
        )
        const formattedDate = initialDate.format('M/D/YYYY h:mm:ss A')
        setSelecteddueDate(formattedDate)
        setSelectedDueDateFromChild(dayjs(formattedDate).format('DD/MM/YYYY'))
    }, [individualTaps?.individualPersonalDetails?.dueDate])

    const onChange = (dateOfBirth: DatePickerProps['value']): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            setSelectedDateOfBirthFromChild(isoDate)
            form.setFieldValue('dateOfBirth', isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }
    const onDueDateChange = (dateOfBirth: DatePickerProps['value']): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelecteddueDate(isoDate)
            setSelectedDueDateFromChild(isoDate)
            form.setFieldValue('dueDate', isoDate)
            void form.validateFields(['dueDate'])
        }
    }
    return (
        <>
            <Form.Item
                label="Date Of Birth"
                name="dateOfBirth"
                rules={[
                    {
                        validator: async (_, value) =>
                            await validateDate(value),
                    },
                ]}
            >
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <DatePicker
                        allowClear
                        onChange={onChange}
                        value={
                            selectedDate.length > 0 ? dayjs(selectedDate) : null
                        }
                        format="DD/MM/YYYY"
                        disabledDate={(current) =>
                            current !== null && current > dayjs().endOf('day')
                        }
                        style={{ width: '100%' }}
                    />
                </Space>
            </Form.Item>
            {/* <Form.Item label="NI Number" name="niNumber">
                <Input allowClear maxLength={9} />
            </Form.Item> */}
            <InputFieldNINumber name="niNumber" form={form} />
            <Form.Item
                label="Duedate"
                name="dueDate"
                rules={[
                    {
                        validator: async (_, value) =>
                            await validateDate(value),
                    },
                ]}
            >
                <Space direction="vertical" size={12}>
                    <DatePicker
                        allowClear
                        onChange={onDueDateChange}
                        value={
                            selectDusDate.length > 0
                                ? dayjs(selectDusDate)
                                : null
                        }
                        format="DD/MM/YYYY"
                        className={commonStyles.dateWidth}
                        disabledDate={(current) =>
                            current !== null && current > dayjs().endOf('day')
                        }
                    />
                </Space>
            </Form.Item>

            <Form.Item
                label="Mobile Number"
                name="mobileNumber"
                rules={[
                    {
                        pattern: /^\d{10,15}$/,
                        message: 'please enter valid mobile number',
                    },
                    {
                        required: true,
                        message: 'Please input your mobile number!',
                    },
                ]}
            >
                <Input allowClear maxLength={15} />
            </Form.Item>
            <Form.Item
                label="Home Number"
                name="homeNumber"
                rules={[
                    {
                        pattern: /^\d{10,15}$/,
                        message: 'please enter valid mobile number',
                    },
                ]}
            >
                <Input allowClear maxLength={15} />
            </Form.Item>
            <Form.Item
                label="Work Number"
                name="workNumber"
                rules={[
                    {
                        pattern: /^\d{10,15}$/,
                        message: 'please enter valid mobile number',
                    },
                ]}
            >
                <Input allowClear maxLength={15} />
            </Form.Item>
            <Form.Item
                label="Email Address"
                name="emailAddress"
                rules={[
                    {
                        type: 'email',
                        required: true,
                        message: 'Please input your email!',
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item
                label="Alternative Email Address"
                name="alternativeEmailAddress"
                rules={[
                    {
                        type: 'email',
                        message: 'Please Input Alternative Email!',
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
        </>
    )
}

const mapStateToProps = (state: any): RegisterInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        individualTaps: state.client.individualTaps,
    }
}

export default connect(mapStateToProps)(PersonalDetailsForm)
